import * as Yup from 'yup'
import { AppDispatch } from '../../redux/utils/AppDispatch'
import {
  registerPremiumAction,
  _REGISTER_END_LOADING,
  _REGISTER_START_LOADING,
} from '../../redux/actions/RegisterActions'

export const handleValidation = () => {
  return Yup.object().shape({
    dni: Yup.string()
      .required('El número de identificación es requerido')
      .max(8, 'El DNI debe ser de 8 digitos')
      .min(8, 'El DNI debe ser de 8 digitos')
      .matches(/^[0-9]+$/, 'El DNI es sólo número'),
    email: Yup.string().email('No es un email válido').required('El email es requerdio'),
    password: Yup.string()
      .required('La contraseña es requerida')
      .min(8, 'La contraseña debe tener más de 8 caracteres')
      .max(12, 'La contraseña debe tener un máximo de 12 caracteres')
      .matches(
        /^.*(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
        'Contraseña debe tener al menos una letra mayuscula, minuscula y un número'
      )
      .oneOf([Yup.ref('password_confirmation'), null], 'Las contraseñas no son iguales'),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Las contraseñas no son iguales')
      .required('La confirmación del password es requerida'),
    accepts: Yup.boolean()
      .oneOf([true], 'Debe aceptar los términos y condiciones')
      .required('Debe aceptar los términos y condiciones'),
    accepts_policies: Yup.boolean(),
    isProd: Yup.boolean(),
    reCaptcha: Yup.string().when('isProd', {
      is: true,
      then: Yup.string().required('El reCaptcha es requerido').nullable(),
    }),
  })
}

export const initialValues = {
  dni: '',
  email: '',
  address: '',
  password: '',
  password_confirmation: '',
  accepts: false,
  accepts_policies: false,
  dni_type: '1',
  country: 'Peru',
  department: '15',
  district: '',
  city: '',
  gender: '1',
  isProd: process.env.NODE_ENV === 'production',
  reCaptcha: '',
}

export const handleRegister = (formValue) => {
  AppDispatch(registerPremiumAction({ ...formValue }))
}
